import React from 'react';
import { ProgressIndicator, ProgressStep } from 'carbon-components-react';

const ProgressIndicatorVertical: React.FC<Props> = ({ currentStep }) => {
  let stepIndex = currentStep - 1;
  if (currentStep === 4) {
    stepIndex = 2;
  }
  return (
    <div id="progressSection" className="progress-section-container">
      <div id="progressSection" className="progress-title">
        Account setup progress
      </div>
      <div id="progressSection" className="progress-description">
        Get up and running with SmarterWX Locate in just a few simple steps
      </div>
      <div
        id="progressIndicator"
        className="progress-indicator-wrapper vertical-progress-indicator-width"
      >
        <ProgressIndicator currentIndex={stepIndex} vertical={true}>
          <ProgressStep label="Profile" secondaryLabel="Tell us about you" />
          <ProgressStep
            label="BYDA Details"
            secondaryLabel="Allows us to fetch, display and lodge enquiries"
          />
          <ProgressStep
            label="Authorisation"
            secondaryLabel="Verify your email account and import recent enquiries"
          />
        </ProgressIndicator>
      </div>
    </div>
  );
};

type Props = {
  currentStep: number;
};

export default React.memo(ProgressIndicatorVertical);
